import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button/Button';
import Svg from '../../components/SVG/SVG';
import RequestTable from './RequestTable';

moment.tz.setDefault('Europe/Kiev');

const RequestList = () => {
  const [isWorkTime, setIsWorkTime] = useState(true);

  useEffect(() => {
    const checkDay = () => {
      const now = moment();
      const day = now.day(); // 0 - неділя, 6 - субота

      // Рабочие дни: понедельник - пятница
      const isWorkDay = day >= 1 && day <= 5;
      setIsWorkTime(isWorkDay);
    };

    checkDay();
    const interval = setInterval(() => {
      checkDay();
    }, 60000); // Оновлювати кожну хвилину

    return () => clearInterval(interval);
  }, []);

  // Определяем ссылку в зависимости от дня недели
  const createRequestLink = isWorkTime
    ? '/create-request'
    : '/create-request?f8b0f38b-60fd-42d9-b87d-39e704ed6d27';
  return (
    <div className="request-page-list">
      <div className="request-list boxes">
        <div className="box request-item-header">
          <div className="request-item-header-title">
            <div className="text-black-bold-f19-l33">Звернення</div>
            <div className="text-grey-normal-f16-l28">
              Тут зберігаються усі звернення компанії та статуси їх виконання
            </div>
          </div>
          <Link to={createRequestLink}>
            <Button className="request-item-btn request-item-btn--create" text="Створити" bg="pink">
              <Svg name="create" />
            </Button>
          </Link>
        </div>
        <div className="box request-list-content">
          <RequestTable />
        </div>
      </div>
    </div>
  );
};

export default RequestList;
